const map = {
	"./footerLinks.el-cy.CY.json": [
		83326,
		[
			885
		]
	],
	"./footerLinks.el.GR.json": [
		45268,
		[
			8076
		]
	],
	"./footerLinks.en-ie.IE.json": [
		74776,
		[
			8087
		]
	],
	"./footerLinks.en-pt.PT.json": [
		96556,
		[
			5278
		]
	],
	"./footerLinks.en.CY.json": [
		29071,
		[
			1873
		]
	],
	"./footerLinks.en.GR.json": [
		59266,
		[
			9064
		]
	],
	"./footerLinks.pt-pt.PT.json": [
		52663,
		[
			5267
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 74943;
module.exports = webpackAsyncContext;